<template>
    <div>
        <div class="card">
            <div class="card-header main-card">
                Administración de grupos de actividades
            </div>
            <div class="card-body">
                <b-container>
                    <div class="mb-4">
                        <span class="mr-4">
                            Selecciona la zona
                        </span>
                        <b-form-select @change="getData" v-model="suprazone_id" class="">
                            <option value="0">Seleccione zona...</option>
                            <option v-for="suprazone in suprazones" :key="suprazone.id" :value="suprazone.id">{{suprazone.name}}</option>
                        </b-form-select>
                    </div>
                    <div class="mb-1" v-if="suprazone_id > 0 ">
                        <b-dropdown
                            size="lg"
                            variant="link"
                            toggle-class="text-decoration-none"
                            class="float-right"
                            no-caret
                        >
                            <template v-slot:button-content>
                                <i class="fa fa-ellipsis-v"></i>
                            </template>
                            <b-dropdown-item>
                                <div v-b-modal="'addActivityGroup'">
                                    <i class="fa fa-plus-circle mr-2 fa-fw"/> Nuevo
                                </div>
                                <admin-add-activity-group-modal :suprazone="suprazone" />
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <table class="table table-hover table-bordered table-sm mt-1">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Nombre</th>
                                <th scope="col">Punto de encuentro</th>
                                <th scope="col">Hora de inicio</th>
                                <th scope="col">Gestionar</th>
                                <th scope="col">Configurar</th>
                            </tr>
                        </thead>
                        <tbody v-if="groupsListAdmin.length > 0">
                            <admin-activity-group-table-row
                                :item="group" v-for="group in groupsListAdmin" :key="group.id"
                                :suprazone="suprazone"    
                             />
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td v-if="suprazone_id != 0" colspan="3" class="text-center">No hay groups creados para la zona de {{suprazone.name}}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-container>
            </div>
        </div>
    </div>
</template>


<script>
/* eslint-disable */
import AdminActivityGroupTableRow from './AdminActivityGroupTableRow'
import AdminAddActivityGroupModal from './AdminAddActivityGroupModal'
import { mapGetters } from 'vuex'

export default {
    components: {
        AdminActivityGroupTableRow,
        AdminAddActivityGroupModal,
    },
    data() {
        return {
            suprazone: {},
            suprazone_id: 0,
        }
    },
    beforeDestroy() {
        // clean list
        this.$store.commit('groups/RESET_GROUPS_LIST_ADMIN')
    },
    async mounted() {
        this.$store.commit('groups/RESET_GROUPS_LIST_ADMIN')
        await this.$store.dispatch("suprazones/loadSuprazones")
    },
    computed: {
        ...mapGetters(['suprazones', 'suprazoneAdminCurrent', 'groupsListAdmin'])
    },
    methods: {
        async getData() {
            const data = {
                suprazone_id: this.suprazone_id,
            }
            await this.$store.dispatch('groups/loadGroupsBySuprazone', data)
            
            this.suprazone = this.suprazoneAdminCurrent(this.suprazone_id)

        }
    }
}
</script>
